// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1bdd9537","683":"17028372","978":"6e115093"}[chunkId] + ".chunk.js";
};